import React from "react";
import { Route, withRouter, RouteChildrenProps } from "react-router";
import PartnershipOverview from "./PartnershipOverview";
import Branding from "./Branding";
import Tiers from "./Tiers";
import IntegrationRoutes from "./IntegrationRoutes";

const PartnershipRoutes = (props: RouteChildrenProps) => {
  let path = "";
  const { match } = props;
  if (match && match.path) {
    path = match.path;
  }

  return (
    <>
      <Route exact path={`${path}/overview`} component={PartnershipOverview} />
      <Route exact path={`${path}/tiers`} component={Tiers} />
      <Route exact path={`${path}/branding`} component={Branding} />
      <Route path={`${path}/integrations`} component={IntegrationRoutes} />
      <Route exact path={path} component={PartnershipOverview} />
    </>
  );
};

export default withRouter(PartnershipRoutes);
